<template>
    <div class="flex flex-col">
        <h3 class="mb-2 text-lg font-bold text-gray-400">
            Evolução do Score
        </h3>
        <line-chart 
            :series="series" 
            :loading="loading" 
            :enable-point-click="true"
            @point-click="onPointClick"
        />
    </div>
</template>

<script>
import LineChart from "../../analytics/charts/LineChart.vue";

export default {
    components: { LineChart },
    props: ["user"],
    emits: ['score-selected'],
    data() {
        return {
            loading: true,
            series: [],
            scoresData: [],
        };
    },
    mounted() {
        this.fetchScoreHistory();
    },
    methods: {
        filterClosePoints(scores) {
            if (scores.length <= 1) return scores;
            
            const minTimeGap = 3 * 24 * 60 * 60 * 1000; // 3 dias em milliseconds
            const filtered = [scores[0]]; // sempre inclui o primeiro ponto
            
            for (let i = 1; i < scores.length; i++) {
                const currentTime = new Date(scores[i].created_at).getTime();
                const lastTime = new Date(filtered[filtered.length - 1].created_at).getTime();
                
                // Se a diferença for maior que 3 dias OU for o último ponto, inclui
                if (currentTime - lastTime >= minTimeGap || i === scores.length - 1) {
                    filtered.push(scores[i]);
                }
            }
            
            return filtered;
        },

        async fetchScoreHistory() {
            this.loading = true;
            try {
                const { data } = await axios.get(`/api/user/${this.user.id}/score/history`);
                
                // Armazenar os dados completos para referência
                this.scoresData = data.scores;
                
                // Filtrar pontos muito próximos para melhor visualização
                const filteredScores = this.filterClosePoints(data.scores);
                
                const scoreSeries = {
                    name: "Score",
                    data: filteredScores.map((score) => ({
                        x: new Date(score.created_at).getTime(),
                        y: Number(score.amount),
                        pointData: {
                            id: score.id,
                            created_at: score.created_at
                        }
                    })),
                    lineWidth: 3,
                    marker: {
                        enabled: false, // Sem marcadores visíveis por padrão
                        symbol: 'circle'
                    }
                };
                
                this.series = [scoreSeries];
                
            } catch (error) {
                console.error("Erro ao buscar histórico de scores:", error);
            } finally {
                this.loading = false;
            }
        },
        
        onPointClick(pointInfo) {
            if (pointInfo.pointData && pointInfo.pointData.id) {
                this.$emit('score-selected', pointInfo.pointData.id);
            }
        },
    }
};
</script>
